import { http } from "@/utils/request";

/**
 * 获取官网基础信息配置。
 */
export const useGetWebsiteBasicInfoListApi = async (params) => {
  console.log("官网基础信息接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteBasicInfoList", params);
  console.log("官网基础信息接口-返回数据", res);
  return res;
};

/**
 * 将技术实力配置解析为首页指标所需的数据结构。
 * 兼容接口返回一条逗号分隔的 paramValue，或多条独立记录。
 */
export const parseTechnicalIndicators = (records) => {
  if (!Array.isArray(records)) return [];

  return records.reduce((result, record) => {
    const rawValue = String(record && record.paramValue ? record.paramValue : "");
    const values = rawValue
      .split(/[，,]/)
      .map((value) => value.trim())
      .filter(Boolean);

    values.forEach((value) => {
      const separatorIndex = Math.max(value.lastIndexOf(":"), value.lastIndexOf("："));
      const hasName = separatorIndex > -1;
      const name = hasName
        ? value.slice(0, separatorIndex).trim()
        : (record && (record.paramNameCn || record.paramName)) || "";
      const title = hasName ? value.slice(separatorIndex + 1).trim() : value;

      if (title) {
        result.push({ title, name });
      }
    });

    return result;
  }, []);
};

/**
 * 将机构城市配置拆成首页地图区域使用的两行文本。
 */
export const parseDistributionCities = (records) => {
  if (!Array.isArray(records)) return [];

  const cities = records
    .flatMap((record) => String(record && record.paramValue ? record.paramValue : "").split(/[，,]/))
    .map((city) => city.trim())
    .filter(Boolean);

  if (!cities.length) return [];

  const firstLineSize = Math.ceil(cities.length / 2);
  return [cities.slice(0, firstLineSize), cities.slice(firstLineSize)]
    .filter((line) => line.length)
    .map((line) => line.join("、"));
};

export const parseBasicInfoText = (records) => {
  const record = Array.isArray(records) && records[0];
  return record && typeof record.paramValue === "string" ? record.paramValue.trim() : "";
};

export const parseSubsidiaryLogos = (records) => {
  const rawValue = Array.isArray(records)
    ? records.map((record) => (record && record.paramValue) || "").join("\n")
    : "";
  return rawValue.match(/https?:\/\/[^\s,"]+/g) || [];
};
